<template>
  <div class="section-right-content-box">
    <div class="tip-wrap">
      <div class="card-point tipBg">
        <div class="card-rule" style="width: 24px;"></div>
        <div class="card-connet">
          <p>仅可对2024-11-12(含)之后创建的互动活动进行汇总分析</p>
        </div>
      </div>
    </div>
    <div>
      <el-form label-width="10px">
        <el-form-item>
          <span style="margin-right: 20px">活动时间 :</span>
          <el-radio
            v-model="queryForm.evaluateTime"
            @change="timeChange"
            v-for="item in options.evaluateTimeOpt"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="postForm.startDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div
              class="time_to_text"
              :class="{
                to_text_disabled:
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
              }"
            >
              至
            </div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="postForm.endDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="true"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <span style="margin:0px 20px">活动类型 :</span>
          <el-select v-model="activityTypeParent" placeholder="请选择" style="margin-right:10px" @change="activityTypeParentChange">
            <el-option
              v-for="item in activityTypeParentList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="activityType" placeholder="请选择" v-if="activityTypeParent">
            <el-option
              v-for="item in activityTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button class="b1" style="margin-left: 20px" v-zoom="{ from: '忠诚度管理-数据分析-活动数据', name: '查询' }" @click="queryTotal()"
              ><span style="marginleft: 4px">
                <i
                  class="el-icon-search"
                  style="
                    display: inline-block;
                    width: 14px;
                    height: 12px;
                    fontweight: bold;
                    margin-right: 4px;
                  "
                ></i
                >查询</span
              ></el-button
            >
          <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span style="marginleft: 4px">重置</span></el-button>
        </el-form-item>
        <el-form-item>
          <el-dropdown @command="exportRule($event)" style="float:right">
            <el-button type="default"
              >导出 <i class="el-icon-arrow-down ml-5"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="setting">导出字段设置</el-dropdown-item>
              <el-dropdown-item command="exportAll">导出数据（全部）</el-dropdown-item>
              <el-dropdown-item command="exportSetting">导出数据（按设置）</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下单转化 -->
    <div class="titClass">
      <div class="down">
        下单转化
        <el-popover
          placement="top-start"
          width="400"
          offset="100"
          trigger="hover"
          data-html="true"
        >
          <span>转化数据说明：</span><br />
          <span> 1、人群:参与活动的用户。</span><br />
          <span>
            2、时间:活动开始至T+1
            (昨日)的累计成交数据，每天中午12:30后更新。</span
          ><br />
          <span> 3、订单维度:已付款的在线支付订单或者选择货到付款的订单。</span
          ><br />
          <span>
            4、备注:活动结束后15天内的数据都可以统计，超过15天的数据将无法统计。</span
          ><br />
          <span>
            5、由于京东数据的限制，活动开始和结束时间只能以活动首次创建的时间为准;中途修改活动时间，无法更新转化数据的统计时间范围。</span
          ><br />
          <span style="float: right" slot="reference">
            <p class="question_iconOne">?</p>
          </span>
        </el-popover>
      </div>
      <div class="borderU"></div>
      <div class="titClassOne" v-for="(v, index) in hostList" :key="index">
        <div style="color: #333333; font-size: 14px">
          {{ v.name }}
        </div>
        <div style="color: #1f1f1f; font-size: 18px; font-weight: 600">
          {{
            index == 0
              ? tatal_num.users
              : index == 1
              ? tatal_num.ordNum
              : index == 2
              ? tatal_num.gmv
              : (tatal_num.ordRate * 100).toFixed(2)
          }}
          <span style="color: #999999; font-size: 14px">
            {{
              index == 0 ? "人" : index == 1 ? "单" : index == 2 ? "元" : "%"
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据总览</span>
    </div>
    <div class="switch">
      <el-tabs v-model="switchIndex" class="switch-tabs">
        <el-tab-pane label="互动参与" name="1"></el-tab-pane>
        <el-tab-pane label="浏览店铺" name="2"></el-tab-pane>
        <el-tab-pane label="浏览商品" name="3"></el-tab-pane>
        <el-tab-pane label="下单" name="4"></el-tab-pane>
        <el-tab-pane label="入会" name="5"></el-tab-pane>
        <el-tab-pane label="中奖" name="6"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-loading="loading">
      <div
        class="overview1"
        style="float: left"
        v-for="(item, index) in dataSummary"
        :key="index + item.value"
      >
        <div>
          <span class="fontClass">{{ item.name }}</span>
          <el-popover
            v-if="item.tipsName"
            placement="top-start"
            width="200"
            offset="100"
            trigger="hover"
            :content="item.tipsName"
          >
            <span style="float: right; margin-top: -10px" slot="reference">
              <p class="question_icon">?</p>
            </span>
          </el-popover>
        </div>
        <div class="num">{{ tableTotal[item.value] }}</div>
      </div>
    </div>
    <div
      style="clear: left"
      ref="payRemindChart2"
      class="chart"
      v-loading="loading"
    ></div>
    <div class="new-table-box" style="margin-top: 20px">
      <el-table
        :data="chartEffectDetail"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%;"
      >
        <el-table-column
          prop="dateTime"
          label="日期"
        >
        </el-table-column>
        <el-table-column
          v-for="item in dataSummary"
          :prop="item.value"
          :label="item.name"
          :key="item.value"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 获取验证码弹窗 -->
    <verify-code-dialog 
      :visible.sync="visible" 
      @confirm="handleVerifyConfirm"
      @cancel="handleVerifyCancel"
    />
    <!-- 导出字段设置弹窗 -->
    <export-field-setting-dialog 
      :visible.sync="exportSettingDialog" 
      :export-fields-data="exportFieldsData" 
      :export-field-loading="exportFieldLoading" 
      @save="handleExportFieldsSave" 
      @close="handleExportFieldsClose" 
    />
  </div>
</template>

<script>
import echarts from "echarts";
import {
  getCouponData,
  getShopGiftParticipateConver,
  checkRecord,
  getFieldJsonConfig,
  saveFieldJsonConfig,
  exportStatistics,
} from "@/api/integralCenter/PointActivityAnalyticController";
import { getmoble, getSellerCheckCode } from "@/api/paradiseAndTaskCommonController.js";
import exportFieldSettingDialog from '@/views/integralCenter/components/activity_data_statistics_new/_components/exportFieldSettingDialog.vue'
import verifyCodeDialog from '@/views/integralCenter/components/_components/verifyCodeDialog.vue';
export default {
  components: {
    exportFieldSettingDialog,
    verifyCodeDialog,
  },
  data() {
    return {
      joinSummary: [
        {
          value: "actPv", // 对应tableTotal的字段
          name: "PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动的累计来访PV", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "actUv",
          name: "UV",
          tips: true,
          tipsName: "活动的累计来访UV，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "participatePv",
          name: "参与次数",
          tips: true,
          tipsName:
            "符合活动参与行为的用户参与次数汇总，用户可能在活动中参与多次，根据活动类型而定",
          color: "#F4ACB9",
        },
        {
          value: "participateUv",
          name: "参与人数",
          tips: true,
          tipsName:
            "符合活动参与行为的用户数汇总、包括但不限于：抽奖、领奖、分享、签到等，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "participateAvg",
          name: "人均参与次数",
          tips: true,
          tipsName: "参与次数/参与人数。",
          color: "#C2CDDE",
        },
        {
          value: "participateRate",
          name: "参与率",
          tips: true,
          tipsName: "参与人数 / UV",
          color: "#96AA08",
        },
        {
          value: "cartPv",
          name: "加购次数",
          tips: false,
          tipsName: "加购了活动指定商品的累计次数",
          color: "#C2D1C8",
        },
        {
          value: "cartUv",
          name: "加购人数",
          tips: false,
          tipsName: "加购了活动指定商品的累计人数，多日不去重",
          color: "#D39595",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          tipsName: "活动中进行分享的次数",
          color: "#B8C7F3",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          tipsName: "活动中进行分享的人数，单日去重，多日不去重",
          color: "#A7878E",
        },
      ],
      stoneSummary: [
        {
          value: "scanshopPv",
          name: "浏览店铺次数",
          tips: false,
          tipsName: "累计从活动页跳转并浏览店铺PV",
          color: "#EFB37E",
        },
        {
          value: "scanshopUv",
          name: "浏览店铺人数",
          tips: false,
          tipsName: "累计从活动页跳转并浏览店铺UV，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "scanshopRate",
          name: "浏览率",
          tips: false,
          tipsName: "浏览店铺人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "followshopUv",
          name: "新增店铺关注人数",
          tips: false,
          tipsName: "活动中累计关注店铺的人数，不去重",
          color: "#F2D0B5",
        },
        {
          value: "followshopPv",
          name: "新增店铺关注次数",
          tips: false,
          tipsName: "活动中累计关注店铺的次数",
          color: "#C2CDDE",
        },
        {
          value: "followshopRate",
          name: "店铺关注率",
          tips: false,
          tipsName: "新增店铺关注人数/ 参与人数",
          color: "#96AA08",
        },
      ],
      goodsSummary: [
        {
          value: "scanskuPv",
          name: "浏览商品次数",
          tips: false,
          tipsName: "活动中浏览任意商品的次数",
          color: "#EFB37E",
        },
        {
          value: "scanskuUv",
          name: "浏览商品人数",
          tips: false,
          tipsName: "活动中浏览任意商品的人数，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "scanskuRate",
          name: "浏览商品率",
          tips: false,
          tipsName: "浏览商品人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "followskuUv",
          name: "商品关注人数",
          tips: false,
          tipsName: "活动中关注了任意商品的累计人数，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "followskuPv",
          name: "商品关注次数",
          tips: false,
          tipsName: "活动中关注了任意商品的累计次数",
          color: "#C2CDDE",
        },
        {
          value: "followSkuRate",
          name: "商品关注率",
          tips: false,
          tipsName: "商品关注人数 / 参与人数",
          color: "#96AA08",
        },
      ],
      orderSummary: [
        {
          value: "orderPayGmv",
          name: "下单GMV(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的按订单金额汇总",
          color: "#EFB37E",
        },
        {
          value: "orderPayNum",
          name: "下单人数(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的用户数",
          color: "#B2A8DA",
        },
        {
          value: "orderPayQuantity",
          name: "总下单数(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的订单数汇总",
          color: "#F4ACB9",
        },
        {
          value: "price",
          name: "客单价",
          tips: false,
          tipsName: "下单GMV(付款) / 下单人数(付款)",
          color: "#F2D0B5",
        },
        {
          value: "orderQuantityAvg",
          name: "平均单量",
          tips: false,
          tipsName: "总下单数(付款) / 下单人数(付款)",
          color: "#C2CDDE",
        },
        {
          value: "orderConversionRate",
          name: "下单转化率",
          tips: false,
          tipsName: "下单人数(付款) / 参与人数",
          color: "#96AA08",
        },
        {
          value: "newOpenCardOrderQuantity",
          name: "新增会员下单人数",
          tips: false,
          tipsName: "活动中新增入会的用户，在活动中累计产生订单的用户数",
          color: "#3498DB",
        },
        {
          value: "oldOpenCardOrderNum",
          name: "老会员下单人数",
          tips: false,
          tipsName: "非活动中入会的会员用户（参与活动用户中为会员身份的用户数量减去新增入会用户），在活动中累计产生订单的用户数",
          color: "#E74C3C",
        },
        {
          value: "newOpenCardOrderGmv",
          name: "新增会员下单金额",
          tips: false,
          tipsName: "活动中新增入会的用户，在活动中累计产生订单的付款金额",
          color: "#9B59B6",
        },
        {
          value: "oldOpenCardOrderGmv",
          name: "老会员下单金额",
          tips: false,
          tipsName: "非活动中入会的会员用户（参与活动用户中为会员身份的用户数量减去新增入会用户），在活动中累计产生订单的付款金额",
          color: "#F39C12",
        },
      ],
      fanSummary: [
        {
          value: "newOpenCardNum",
          name: "新增入会人数",
          tips: false,
          tipsName: "活动中新增入会的用户人数，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "openCardConversionRate",
          name: "入会转化率",
          tips: false,
          tipsName: "新增会员人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "newOpenCardOrderNum",
          name: "新增会员下单人数",
          tips: false,
          tipsName:
            "活动中新增入会的用户且进行下单的人数，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "newOpenCardOrderGmv",
          name: "新增会员下单GMV(付款)",
          tips: false,
          tipsName: "活动中新增入会在本次活动期间符合下单条件的GMV",
          color: "#C2CDDE",
        },
        {
          value: "newOpenCardOrderQuantity",
          name: "新增会员下单数(付款)",
          tips: false,
          tipsName: "活动中新增入会在本次活动期间符合下单条件的下单次数",
          color: "#96AA08",
        },
        {
          value: "newOpenCardPrize",
          name: "新增会员客单价",
          tips: false,
          tipsName: "新增粉丝下单GMV(付款) / 新增粉丝下单人数",
          color: "#C2D1C8",
        },
      ],
      prizeSummary: [
        {
          value: "accumulateWinTimes",
          name: "累计中奖次数",
          tips: false,
          tipsName: "活动中累计中奖的次数",
          color: "#EFB37E",
        },
        {
          value: "accumulateWinNum",
          name: "累计中奖人数",
          tips: false,
          tipsName: "活动中累计中奖的人数，单日去重，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "winRate",
          name: "中奖率",
          tips: false,
          tipsName: "累计中奖人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "accumulateReceiveNum",
          name: "累计领奖人数",
          tips: false,
          tipsName: "活动中累计领奖的人数，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "receiveRate",
          name: "领奖率",
          tips: false,
          tipsName: "累计领奖人数/中奖人数",
          color: "#C2CDDE",
        },
      ],
      hostList: [
        {
          name: "下单用户量",
          nameOne: 100,
        },
        {
          name: "下单订单总量",
          nameOne: 100,
        },
        {
          name: "下单金额",
          nameOne: 100,
        },
        {
          name: "下单转化率",
          nameOne: 100,
        },
      ],
      tatal_num: {},
      topSelect: 1,
      //折线图数据
      myCharts: null,
      tableTotal: {},
      chartEffectDetail: [],
      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      countTable: [],
      loading: true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      tabList: [
        {
          label: "活动数据(新)",
          value: 1,
        },
        {
          label: "活动数据(旧)",
          value: 2,
        },
      ],
      switchIndex: "1",
      activityTypeParentList: [
        { label: "全部", value: '' },
        { label: "互动玩法", value: 'activity' },
        { label: "积分兑换", value: 'credits' },
        { label: "礼包弹窗", value: 'gift' },
        // { label: "小部件", value: 'widget' },
        // { label: "促销方式", value: 'promotion' },
      ],
      activityList:[{
          value: 1,
          label: "日历签到",
        },
        {
          value: 4,
          label: "关注店铺有礼",
        },
        {
          value: 17,
          label: "首单专享礼",
        },
        {
          value: 16,
          label: "下单有礼",
        },
        {
          value: 19,
          label: "下单抽奖",
        },
        {
          value: 18,
          label: "复购有礼",
        },
        {
          value: 34,
          label: "加购有礼",
        },
        {
          value: 36,
          label: "下单冲榜",
        },
        {
          value: 27,
          label: "预售有礼",
        },
        {
          value: 28,
          label: "预售抽奖",
        },
        {
          value: 8,
          label: "幸运抽奖",
        },
        {
          value: 7,
          label: "完善信息有礼",
        },
        {
          value: 20,
          label: "评价有礼",
        },
        {
          value: 3,
          label: "每日限时抢",
        },
        {
          value: 22,
          label: "天降红包雨",
        },
        {
          value: 23,
          label: "欢乐娃娃机",
        },
        {
          value: 24,
          label: "大家来找茬",
        },
        {
          value: 5,
          label: "邀请开卡有礼",
        },
        {
          value: 6,
          label: "邀请关注有礼",
        },
        {
          value: 21,
          label: "裂变神券",
        },
        {
          value: 31,
          label: "超级裂变券",
        },
        {
          value: 39,
          label: "生日有礼",
        },
        {
          value: 50,
          label: "情书贺卡",
        },
      ],
      creditsList:[
        { label: "兑换实物", value: 9 },
        { label: "兑换优惠券", value: 10 },
        { label: "兑换京豆", value: 29 },
        { label: "兑换E卡", value: 30 },
        { label: "兑换红包", value: 38 }
      ],
      giftList:[
        {
          value: 13,
          label: "开卡礼包",
        },
        {
          value: 14,
          label: "店铺礼包",
        },
        {
          value: 15,
          label: "店铺礼包（千人千面）",
        }
      ],
      widgetList:[
        {
          value: 33,
          label: "0元试用",
        },
        {
          value: 32,
          label: "会员卡片",
        },
        {
          value: 26,
          label: "刮刮乐",
        },
        {
          value: 25,
          label: "智能活动海报",
        }
      ],
      promotionList:[
        {
          value: 15,
          label: "白条免息活动",
        }
      ],
      activityTypeParent:"",
      activityType:"",
      activityType:"",
      visible: false, // 控制获取验证码弹窗
      phone: '',
      countdown: 60,
      code: "",
      codeDisabled: false,
      codeMsg: "获取验证码", // 按钮上的文字
      exportSettingDialog: false, // 导出设置弹窗
      exportType: 0, // 导出类型 0全部导出 1部分导出
      exportFieldLoading: false, // 导出字段加载状态
      selectedFields: [], // 已选中的字段
      tempExportFieldsData: [], // 添加临时导出字段数据副本(确保在点击弹窗的确认按钮时才修改数据状态)
      // 导出字段设置
      exportFieldsData: [
      {
        label: '基础信息',
        export: true,
        group: '基础信息',
        disabled: true,
        children: [
          {
            label: '活动类型',
            export: true,
            prop: 'activityType',
            disabled: true,
          },
          {
            label: '活动时间',
            export: true,
            prop: 'activityTime',
            disabled: true,
          },
          {
            label: '统计时间',
            export: true,
            prop: 'statisticsTime',
            disabled: true,
          }
        ]
      },
      {
        label: '互动参与',
        export: false,
        group: '互动参与',
        children: [
          {
            label: '活动PV',
            export: false,
            prop: 'actPv'
          },
          {
            label: '活动UV',
            export: false,
            prop: 'actUv'
          },
          {
            label: '参与次数',
            export: false,
            prop: 'participatePv'
          },
          {
            label: '参与人数',
            export: false,
            prop: 'participateUv'
          },
          {
            label: '人均参与次数',
            export: false,
            prop: 'participateAvg'
          },
          {
            label: '参与率',
            export: false,
            prop: 'participateRate'
          },
          {
            label: '加购次数',
            export: false,
            prop: 'cartPv'
          },
          {
            label: '加购人数',
            export: false,
            prop: 'cartUv'
          },
          {
            label: '分享次数',
            export: false,
            prop: 'sharePv'
          },
          {
            label: '分享人数',
            export: false,
            prop: 'shareUv'
          },
        ]
      },
      {
        label: '浏览店铺',
        export: false,
        group: '浏览店铺',
        children: [
          {
            label: '浏览店铺次数',
            export: false,
            prop: 'scanshopPv'
          },
          {
            label: '浏览店铺人数',
            export: false,
            prop: 'scanshopUv'
          },
          {
            label: '浏览率',
            export: false,
            prop: 'scanshopRate'
          },
          {
            label: '新增店铺关注人数',
            export: false,
            prop: 'followshopUv'
          },
          {
            label: '新增店铺关注次数',
            export: false,
            prop: 'followshopPv'
          },
          {
            label: '店铺关注率',
            export: false,
            prop: 'followshopRate'
          },
        ]
      },
      {
        label: '浏览商品',
        export: false,
        group: '浏览商品',
        children: [
          {
            label: '浏览商品次数',
            export: false,
            prop: 'scanskuPv'
          },
          {
            label: '浏览商品人数',
            export: false,
            prop: 'scanskuUv'
          },
          {
            label: '浏览商品率',
            export: false,
            prop: 'scanskuRate'
          },
          {
            label: '商品关注人数',
            export: false,
            prop: 'followskuUv'
          },
          {
            label: '商品关注次数',
            export: false,
            prop: 'followskuPv'
          },
          {
            label: '商品关注率',
            export: false,
            prop: 'followSkuRate'
          },
        ]
      },
      {
        label: '下单',
        export: false,
        group: '下单',
        children: [
          {
            label: '下单GMV（付款）',
            export: false,
            prop: 'orderPayGmv'
          },
          {
            label: '下单人数（付款）',
            export: false,
            prop: 'orderPayNum'
          },
          {
            label: '总下单数（付款）',
            export: false,
            prop: 'orderPayQuantity'
          },
          {
            label: '客单价',
            export: false,
            prop: 'price'
          },
          {
            label: '平均单量',
            export: false,
            prop: 'orderQuantityAvg'
          },
          {
            label: '下单转化率',
            export: false,
            prop: 'orderConversionRate'
          },
          {
            label: "新增会员下单人数",
            export: false,
            prop: "newOpenCardOrderQuantity",
          },
          {
            label: "老会员下单人数",
            export: false,
            prop: "oldOpenCardOrderNum",
          },
          {
            label: "新增会员下单金额",
            export: false,
            prop: "newOpenCardOrderGmv",
          },
          {
            label: "老会员下单金额",
            export: false,
            prop: "oldOpenCardOrderGmv",
          },
        ]
      },
      {
        label: '入会',
        export: false,
        group: '入会',
        children: [
          {
            label: '新增入会人数',
            export: false,
            prop: 'newOpenCardNum'
          },
          {
            label: '入会转化率',
            export: false,
            prop: 'openCardConversionRate'
          },
          {
            label: '新增会员下单人数',
            export: false,
            prop: 'newOpenCardOrderNum'
          },
          {
            label: '新增会员下单GMV（付款）',
            export: false,
            prop: 'newOpenCardOrderGmv'
          },
          {
            label: '新增会员下单数（付款）',
            export: false,
            prop: 'newOpenCardOrderQuantity'
          },
          {
            label: '新增会员客单价',
            export: false,
            prop: 'newOpenCardPrize'
          },
        ]
      },
      {
        label: '中奖',
        export: false,
        group: '中奖',
        children: [
          {
            label: '累计中奖次数',
            export: false,
            prop: 'accumulateWinTimes'
          },
          {
            label: '累计中奖人数',
            export: false,
            prop: 'accumulateWinNum'
          },
          {
            label: '中奖率',
            export: false,
            prop: 'winRate'
          },
          {
            label: '累计领奖人数',
            export: false,
            prop: 'accumulateReceiveNum'
          },
          {
            label: '领奖率',
            export: false,
            prop: 'receiveRate'
          }
        ]
      },
      ]
    };
  },
  computed: {
    // 数据总览
    dataSummary(){
      if(this.switchIndex == 1){
        return this.joinSummary
      }else if(this.switchIndex == 2){
        return this.stoneSummary
      }else if(this.switchIndex == 3){
        return this.goodsSummary
      }else if(this.switchIndex == 4){
        return this.orderSummary
      }else if(this.switchIndex == 5){
        return this.fanSummary
      }else if(this.switchIndex == 6){
        return this.prizeSummary
      }
    },
    // 活动类型
    activityTypeList(){
      if(this.activityTypeParent == "activity"){
        return this.activityList
      }else if(this.activityTypeParent == "credits"){
        return this.creditsList
      }else if(this.activityTypeParent == "gift"){
        return this.giftList
      }else if(this.activityTypeParent == "widget"){
        return this.widgetList
      }
    }
  },
  watch:{
    switchIndex(){
      this.initChart()
    }
  },
  created() {
    this.timeChange(30);
    this.queryTotal();
  },
  mounted() {
    // this.nextTick();
    this.getExportFieldJsonConfig()
  },
  methods: {
    hugItemBtn(type) {
      this.topSelect = type;
    },
    //查询数据总和
    async queryTotal() {
      this.loading = true;
      //下单转化数据
      const query = {
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
      }
      // 添加活动类型
      if(this.activityType){
        query.activityType = this.activityType
        query.source = [9,10,29,30,38].includes(this.activityType)?2:1
      }
      getShopGiftParticipateConver(query)
        .then((res) => {
          console.log(res);
          this.loading = false;
          if (!res.data) return;
          if (res.code == 1) {
            this.tatal_num = res.data;
          } else {
            this.tatal_num = {
              gmv: 0,
              newShopGmv: 0,
              newShopUsers: 0,
              ordNum: 0,
              ordRate: 0,
              users: 0,
            };
          }
        })
        .catch(() => {
          this.tatal_num = {
            gmv: 0,
            newShopGmv: 0,
            newShopUsers: 0,
            ordNum: 0,
            ordRate: 0,
            users: 0,
          };
          this.loading = false;
        });
      // 活动pv
      getCouponData(query)
        .then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
          console.log(res);
        })
        .catch((res) => {
          this.$message.error("输入时间错误");
        });

      //折线图数据查询
      const { data: dataList } = await checkRecord(query);
      if (dataList.length == 1 && dataList.length == 0) {
        this.$message.error("折线图时间过短");
      } else {
        this.chartEffectDetail = dataList;
        this.$nextTick(() => {
          this.initChart();
          window.addEventListener("resize", () => {
            this.myCharts.resize();
          });
        });
      }
    },
    //折线图
    initChart() {
      if(!this.myCharts){
        this.myCharts = echarts.init(this.$refs.payRemindChart2);
      }else{
        this.myCharts.clear()
      }
      this.setOptions();
    },
    //折线图事件
    setOptions() {
      const seriesList = this.dataSummary.map((item) => {
        return {
          name: item.name,
          type: "line",
          smooth: true,
          color: item.color,
          data: this.chartEffectDetail.map((i) => i[item.value]),
        };
      });
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["活动PV", "活动UV", "活动中心首页PV", "活动中心首页UV", "参与人数", "新增人数", "参与次数", "人均参与次数"],
          data: this.dataSummary.map((item) => item.name),
          bottom: -5,
          left: 'center',
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartEffectDetail.map((item) => item.dateTime),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts.setOption(option);
    },

    //重置
    queryOne() {
      this.queryForm.evaluateTime = "30";
      this.activityTypeParent = ""
      this.activityType = ""
      this.timeChange(30);
      this.queryTotal();
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    timeChange(type) {
      let self = this;
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      console.log(date);
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    // 活动类型change
    activityTypeParentChange(){
      if(this.activityTypeParent == "activity"){
        this.activityType =  this.activityList[0].value
      }else if(this.activityTypeParent == "credits"){
        this.activityType =  this.creditsList[0].value
      }else if(this.activityTypeParent == "gift"){
        this.activityType =  this.giftList[0].value
      }else{
        this.activityType = ""
      }
    },
    // 更新图表
    uploadChart(){
      this.myCharts && this.myCharts.resize()
    },
    async getphone() {
      this.visible = true;
    },
    handleVerifyConfirm(code) {
      this.code = code;
      this.savePhone();
    },
    handleVerifyCancel() {
      // 处理取消逻辑
      this.visible = false;
    },
    // 确认导出
    savePhone() {
      // 导出活动统计数据
      let staticParams = {
        code: this.code,
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
        exportType: this.exportType,
      }
      if(this.activityType){
        staticParams.activityType = this.activityType
        staticParams.source = [9,10,29,30,38].includes(this.activityType)?2:1
      }
      exportStatistics(staticParams).then((res) => {
        if (res.code == 1 || res.code == 200) {
          var blob = new Blob([res.blob]);
          var link = document.createElement("a"); //a标签下载
          link.href = window.URL.createObjectURL(blob);
          link.download = "活动统计.xls";
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.visible = false;
          this.isExportStatistics = false; // 重置状态
        }else {
          this.$message.warning(res.message);
        }
      }).catch((err) => {
        console.log("--- err:---", err)
        this.$message.warning('导出失败');
      })
    },
    // 获取导出字段配置
    getExportFieldJsonConfig() {
      this.exportFieldLoading = true;
      getFieldJsonConfig().then((res) => {
        this.exportFieldLoading = false;
        if (res.code == 200 || res.code == 1) {
          try {
            if (!res.data || res.data === '' || res.data === 'undefined') {
              return;
            }
            if (!res.data.fieldJson || res.data.fieldJson === '' || res.data.fieldJson === 'undefined') {
              return;
            }
            // 解析返回的 JSON 字符串
            const savedFields = JSON.parse(res.data.fieldJson);
            // 创建一个 Set，用于快速查找需要勾选的字段
            const selectedPropsSet = new Set();
            savedFields.forEach(field => {
              selectedPropsSet.add(field.prop);
            });

            // 更新 exportFieldsData 中的 export 状态
            this.exportFieldsData.forEach(group => {
              if (group.children) {
                group.children.forEach(child => {
                  // 如果这个字段的 prop 在接口返回的数据中，就勾选它
                  if (selectedPropsSet.has(child.prop)) {
                    child.export = true;
                  } else {
                    // 如果没有找到，说明它没有被选中（除了默认必选的字段）
                    if (!child.disabled) {
                      child.export = false;
                    }
                  }
                });
                // 更新父级分组的 export 状态
                this.updateParentExportStatus2(group);
              }
            });
            console.log('导出字段配置已更新:', this.exportFieldsData);
          } catch (error) {
            console.log("--- error:---", error)
            this.$message.error('解析导出字段配置失败');
          }
        }
      }).catch((err) => {
        this.exportFieldLoading = false;
        this.$message.error('获取导出字段配置失败');
      });
    },
    // 当子项都勾选了, 父项也勾选
    updateParentExportStatus2(group) {
      if (group.children && group.children.length > 0) {
        // 检查是否有子项被选中
        const hasSelectedChildren = group.children.some(child => child.export);
        // 检查是否所有子项都被选中
        const allChildrenSelected = group.children.every(child => child.export);
        if (allChildrenSelected) {
          group.export = true;
        } else if (hasSelectedChildren) {
          // 部分选中状态，可以根据需要设置为 false 或保持当前状态
          group.export = false;
        } else {
          group.export = false;
        }
      }
    },
    exportRule(type, row) {
      if (type == "setting") {
        console.log("导出字段设置")
        this.exportSettingDialog = true;
      }
      if (type == "exportAll") {
        console.log("导出全部")
        if (this.queryForm.evaluateTime == 0) {
          if (!this.postForm.startDate || !this.postForm.endDate) {
            this.$message.warning("自定义时间不能为空")
            return;
          }
        }
        this.exportType = 0
        this.isExportStatistics = true
        this.getphone()
      }
      if (type == "exportSetting") {
        console.log("按设置导出")
        if (this.queryForm.evaluateTime == 0) {
          if (!this.postForm.startDate || !this.postForm.endDate) {
            this.$message.warning("自定义时间不能为空")
            return;
          }
        }
        this.isExportStatistics = true
        this.exportType = 1
        this.getphone()
      }
    },
    // 处理导出字段保存
    handleExportFieldsSave(tempExportFieldsData) {
      // 将临时数据保存到正式数据
      this.exportFieldsData = JSON.parse(JSON.stringify(tempExportFieldsData));
      const selectedFields = this.generateExportFields(this.exportFieldsData);
      console.log("--- selectedFields:---", selectedFields)
      // 调用保存接口
      let params = {
        fieldJson: JSON.stringify(selectedFields),
        type: 1,
      }
      this.exportFieldLoading = true;
      saveFieldJsonConfig(params).then((res) => {
        this.exportSettingDialog = false;
        if (res.code == 200 || res.code == 1) {
          this.$message.success("保存成功");
          // 重新获取导出字段配置
          this.getExportFieldJsonConfig()
        }
      }).catch((err) => {
        this.$message.error("保存失败");
        this.exportSettingDialog = false;
      });
    },
    // 处理导出字段弹窗关闭
    handleExportFieldsClose() {
      this.exportSettingDialog = false;
    },
    // 生成导出字段列表的通用方法
    generateExportFields(fieldsData) {
      if (!fieldsData || !Array.isArray(fieldsData)) {
        return [];
      }
      const selectedFields = [];
      fieldsData.forEach(parent => {
        // 过滤掉group为'基础信息'的父级数据
        if (parent.group === '基础信息') {
          return;
        }
        if (parent.export && !parent.children) {
          selectedFields.push({
            prop: parent.prop,
            label: parent.label,
            group: parent.group || ''
          });
        }
        if (parent.children) {
          parent.children.forEach(child => {
            if (child.export) {
              selectedFields.push({
                prop: child.prop,
                label: child.label,
                group: parent.group || ''
              });
            }
          });
        }
      });
      return selectedFields;
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-wrap{
  margin-bottom: 16px;
}
.switch {
  margin-top: 16px;
  &-tabs {
    /deep/.el-tabs__header {
      margin-bottom: 0px;
    }
    /deep/.el-tabs__nav-wrap::after{
      background-color: #f6f6f6;
    }
  }
}
.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}

.titileDefinition {
  min-width: 1046px;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  margin: 20px 20px 0 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;
  .titClassOne {
    margin: 0px 100px 0px 30px;
  }
  .down {
    margin-right: 30px;
  }
  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}

.section-right-content-box {
  min-width: 1046px;
  border-bottom: 6px;
  padding: 20px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .tabList {
    display: flex;
    box-sizing: border-box;
    height: 36px;
    line-height: 35px;
    // margin-top: 20px;
    color: #666;
    font-size: 14px;
    margin: 20px 0;
    span {
      margin-right: 3px;
      width: 106px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      vertical-align: middle;
      transform: perspective(1px) translateZ(0);
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #dddddd;
      text-align: center;
    }
    .active {
      position: relative;
      transition: all 0.2s;
      color: #7b61ff;
      border-bottom: none;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        top: 0;
        height: 2px;
        background: #7b61ff;
        border-radius: 6px 6px 0px 0px;
      }
    }
    i {
      flex: 1;
      border-bottom: 1px solid #dddddd;
      margin-left: -3px;
    }
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fff;
    border: 1px solid #7b61ff;
    background-color: #7b61ff;
    &:hover {
      opacity: 0.8;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #7b61ff;
      background-color: #7b61ff;
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: #7b61ff;
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }

  .overview1 {
    padding: 26px 30px 22px 30px;
    width: 182px;
    height: 100px;
    border-right: 1px solid #f3f3f3;
    opacity: 1;
    margin: 20px 0px;
    .fontClass {
      width: 102px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(102, 102, 102, 1);
      opacity: 1;
    }
    .iconbtn_yiwen {
      color: #cccccc;
      font-size: 13px;
      &:hover {
        color: #7b61ff;
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #cccccc;
      display: inline-block;
      line-height: 12px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #cccccc;
      font-size: 12px;
      font-weight: normal;
    }
    .num {
      width: 65px;
      height: 29px;
      font-size: 24px;
      font-family: DIN;
      font-weight: bold;
      line-height: 29px;
      color: #7b61ff;
      opacity: 1;
      margin-top: 14px;
      margin-bottom: 30px;
    }
  }
  .chart {
    // flex: 1;
    height: 380px;
    min-width: 1000px;
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 9px 14px;
  display: flex;
  .card-rule {
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>
